"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namedCapturingGroup = void 0;
exports.escape = escape;
exports.literal = literal;
exports.join = join;
exports.oneOf = oneOf;
exports.absolute = absolute;
exports.optional = optional;
const effect_1 = require("effect");
const string_1 = require("../string");
const specialCharacters = /[.*+?^${}()|[\]\\]/g;
/**
 * Escapes regular expression metacharacters (e.g. `.`, `+`, `(`) within
 * `string`, so that it can be safely embedded within a larger pattern
 * and matched as a literal value.
 */
function escape(string) {
    return string.replace(specialCharacters, String.raw `\$&`);
}
function literal(string) {
    return `(${escape(string)})`;
}
function join(...patterns) {
    return (0, string_1.join)('')(patterns);
}
/**
 * @param literals An array of literals
 * @returns A regular expression pattern for the union of the provided literals
 */
function oneOf(literals) {
    return (0, effect_1.pipe)(literals, effect_1.Array.map(literal), effect_1.Array.join('|'));
}
function absolute(...patterns) {
    return ['^', ...patterns, '$'].join('');
}
exports.namedCapturingGroup = effect_1.Function.dual(2, (pattern, name) => `(?<${name}>${pattern})`);
function optional(pattern) {
    return `${pattern}?`;
}
//# sourceMappingURL=pattern.js.map